import { render, staticRenderFns } from "./earningresource.vue?vue&type=template&id=01077053&scoped=true&"
import script from "./earningresource.vue?vue&type=script&lang=js&"
export * from "./earningresource.vue?vue&type=script&lang=js&"
import style0 from "./earningresource.vue?vue&type=style&index=0&id=01077053&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01077053",
  null
  
)

export default component.exports